var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.coach)?_c('div',[_c('button-tooltip',{attrs:{"icon":"","tooltip":_vm.tooltip,"buttonClass":"stars-btn"},on:{"click":_vm.showSetStarsDialog}},[_c('rating-stars',{attrs:{"value":_vm.stars,"size":"16"}})],1),_c('set-stars-dialog',{ref:"stars",attrs:{"coach":_vm.coach},on:{"success":_vm.onSuccess}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }